import React from 'react';

const VideoItem = ({ video, onVideoSelect }) => {
	return (
		<div onClick={() => onVideoSelect(video)} className='flex flex-row video-item item'>
			<img
				className='image'
				src={video.snippet.thumbnails.medium.url}
				alt={video.snippet.title}
			/>
			<div className=''>
				<h3 className='header text-black'>{video.snippet.title}</h3>
			</div>
		</div>
	);
};

export default VideoItem;
